// extracted by mini-css-extract-plugin
export default {"popoverContainer":"popoverContainer--NzArW","closeButtonContainer":"closeButtonContainer--QvapT","closeButton":"closeButton--GnSyf","animation-bzdot9":"animation-bzdot9--e23F2"};